import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import BigCheckmarkCircleIcon from '../../../../../Cutesies/BigCheckmarkCircleIcon';
import ImportParticipantsStore from '../../../Store';
import { SuccessfulParticipant } from '../../../Store/Types';
import StatusMessage from '../Shared/StatusMessage';
import ViewAndDownloadCSV from '../Shared/ViewAndDownloadCSV';

interface Props {
  successfulParticipants: Array<SuccessfulParticipant>;
  totalCount: number;
  store: ImportParticipantsStore;
}

function SuccessImport({ totalCount, store, successfulParticipants }: Props) {
  return (
    <div className="flex flex-col items-center">
      <StatusMessage
        icon={<BigCheckmarkCircleIcon width="160" height="160" />}
        messageKey="Import Successful"
      />
      <p className="font-semibold text-sm">
        <T kind="{{count}} participants were imported successfully" count={totalCount} />
      </p>
      <ViewAndDownloadCSV store={store} downloadData={successfulParticipants} view="success-view" />
    </div>
  );
}

export default observer(SuccessImport);
